import { Injectable } from '@angular/core';
import { createPublicClient } from 'viem'
import { polygon } from 'viem/chains'
import { polygonAmoy } from '../shared/helpers/polygonAmoy';
import { normaliseChainId, rpcTransport } from '../core/config/rpc-transport';


@Injectable({
    providedIn: 'root'
  })
  
export class publicClientConfig {

    /**
     * Publics client
     * @param {string} chainId 
     * @returns  
     */
    public publicClient(chainId:string | number) {
        const id = normaliseChainId(chainId);
        let networkType:any = polygon;
        if(id == '80002'){
            networkType = polygonAmoy;
        }
        return createPublicClient({
            chain: networkType,
            transport: rpcTransport(id)
        })
    }

}